const AnalyticFields = {
  Day: {
    name: 'date_time',
    label: 'Date',
  },
  State: {
    name: 'state',
    label: 'State',
  },
  City: {
    name: 'city',
    label: 'City',
  },
  Country: {
    name: 'country',
    label: 'Country',
  },
  Source: {
    name: 'content_id',
    label: 'Source',
  },
  Revenue: {
    name: 'ad_revenue',
    label: 'Revenue',
  },
  Impressions: {
    name: 'impressions',
    label: 'Impressions',
  },
  Clicks: {
    name: 'clicks',
    label: 'Clicks',
  },
  Request: {
    name: 'requests',
    label: 'Ad Requests',
  },
};

export default AnalyticFields;
